export const samePath = (path1: string | null, path2: string | null): boolean => {
  if (!path1 || !path2) {
    return false;
  }
  return path1.split('/').join('') === path2.split('/').join('');
}